import classNames from 'classnames'
import React from 'react'
import { formatDateToDDMMYYYY } from '../../../utils/date'
import { getAmount } from '../../../utils/getAmount'
import type { Invoice } from '../../../redux/reducers/invoices'
import styles from './CargoSideModal.module.css'

type UnpaidCargosActionsPanelProps = {
  totalSelectedAmount: number
  currency: string
  selectedCount: number
  onCreateInvoice: () => void
  invoices: Invoice[]
  isPendingGetAllInvoices: boolean
  selectedInvoiceLabel: string
  selectedInvoiceId: string
  isOpenedDropdown: boolean
  setOpenedDropdown: (value: boolean) => void
  onSelectInvoice: (id: number, date: string) => void
  onAttach: () => void
  onDeleteMany: () => void
  className?: string
}

const UnpaidCargosActionsPanel: React.FC<UnpaidCargosActionsPanelProps> = ({
  totalSelectedAmount,
  currency,
  selectedCount,
  onCreateInvoice,
  invoices,
  isPendingGetAllInvoices,
  selectedInvoiceLabel,
  selectedInvoiceId,
  isOpenedDropdown,
  setOpenedDropdown,
  onSelectInvoice,
  onAttach,
  onDeleteMany,
  className,
}) => {
  return (
    <div
      className={classNames(
        styles.slidePanelButton,
        { [styles.disabled]: selectedCount === 0 },
        className
      )}
    >
      <div className={classNames(styles.small, 'row mb-3')}>
        <div className="col">
          <div className={styles.small3}>Выбрано на сумму</div>
          <b>
            <span>{getAmount(totalSelectedAmount)}</span>&nbsp;
            {currency}
          </b>
        </div>
        <div className="col-auto">
          <button
            type="button"
            onClick={onCreateInvoice}
            disabled={selectedCount === 0}
            className={classNames(styles.btn, styles.btnSmall, styles.btnWide)}
          >
            Создать счет
          </button>
        </div>
      </div>

      <div className={styles.small}>Добавить в счёт:</div>
      <div className="row">
        <div className="col pr-1">
          <div
            onClick={() => {
              if (selectedCount !== 0) {
                setOpenedDropdown(!isOpenedDropdown)
              }
            }}
            className={classNames(
              styles.dropdown,
              styles.small2,
              'd-block mb-1',
              isOpenedDropdown && selectedCount !== 0 ? styles.opened : ''
            )}
            style={{ textAlign: 'left' }}
          >
            <div
              className={classNames(
                styles.btn,
                styles.btnSmall2,
                styles.btnWide,
                styles.btnInput,
                styles.btnDropdown,
                styles.nowrap
              )}
            >
              {isPendingGetAllInvoices
                ? 'Загрузка счетов...'
                : selectedInvoiceLabel || 'Выберите счёт'}
            </div>
            <div className={classNames(styles.dropdownContent, styles.dropdownSelect)}>
              {isPendingGetAllInvoices ? (
                <div className={styles.small2} style={{ padding: '10px', textAlign: 'center' }}>
                  Загрузка счетов...
                </div>
              ) : invoices.length > 0 ? (
                invoices.map((item) => (
                  <div
                    key={item.id}
                    data-value={item.id}
                    onClick={() => onSelectInvoice(item.id, item.date)}
                  >
                    №{item.id} от {formatDateToDDMMYYYY(item.date)}
                  </div>
                ))
              ) : (
                <div className={styles.small2} style={{ padding: '10px', textAlign: 'center' }}>
                  Нет доступных счетов
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-auto pl-1">
          <button
            type="button"
            onClick={onAttach}
            disabled={selectedCount === 0 || !Boolean(selectedInvoiceId)}
            className={classNames(
              styles.btn,
              styles.btnSmall2,
              styles.btnWide,
              styles.btnBlueOutline
            )}
          >
            Добавить
          </button>
        </div>
      </div>
      {Boolean(selectedCount) && (
        <div className="mt-3">
          <button
            type="button"
            className={classNames(styles.colorRed, styles.small2, 'btn', 'btn-link', 'p-0', 'text-left')}
            onClick={onDeleteMany}
            style={{ border: 'none', background: 'none', color: 'inherit' }}
          >
            <i className={classNames(styles.icon, styles.iconDelete, styles.icon16, styles.iconRed)} />{' '}
            Удалить выбранные
          </button>
        </div>
      )}
    </div>
  )
}

export default UnpaidCargosActionsPanel
